import chroma from "chroma-js";
import _ from "lodash";
import { DefaultTheme, ThemedStyledProps } from "styled-components";
import { AppType } from "../WSUtils/AppType";

export function getThemeSettingValue(
  props: AppStyledProps,
  camelCaseKey: string
) {
  let value = props[camelCaseKey];

  if (
    camelCaseKey.toLowerCase().endsWith("color") &&
    !chroma.valid(value) &&
    !value.match(/var\(--([a-z-0-9,\s]+)\)/)
  ) {
    return "";
  }

  return value ? `${_.kebabCase(camelCaseKey)}: ${value};` : "";
}

export interface AppStyleProps {
  fontSize: string;
  fontFamily: string;
  backgroundColor: string;
  themeName: string;
  primaryColor: string;
  cssUrl: string;
  appType: AppType;
}

export type AppStyledProps = ThemedStyledProps<AppStyleProps, DefaultTheme>;
